import React from 'react'
import { cn } from '@/utils'

type ParagraphProps = {
    text: string;
    className?: string;
    tAlign?: "center" | "left" | "right";
    size?:number;
  }
  
const Paragraph: React.FC<ParagraphProps> = ({text, tAlign = "left", size, className}) => {
  return (
    <p style={{ fontSize: size}}
    className={cn("text-md text-tblack",
        {
            "text-center": tAlign === "center",
            "text-left": tAlign === "left",
            "text-right": tAlign === "right",
        },
        className
    )}
    >{text}</p>
  )
}

export default Paragraph;